import { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import Header from '../../../components/Layout/Header';
import SideBar from '../../../components/Layout/SideBar';
import { ToastContainer } from 'react-toastify';
import { useParams } from 'react-router-dom';
import Footer from '../../../components/Layout/Footer';
import PartnerDocumentsTable from '../../../components/Cac/Partner/Request/PartnerDocumentsTable';
import { usePartnerRequestDetailsStore } from '../../../stores/Cac/Partner/partnerRequestDetails';
import { gellAllDocuments } from '../../../services/Api/customerService';
import { showToastError } from '../../../services/Toasts/toasts';

const PartnerDocuments = () => {
  const { t } = useTranslation();

  const { idCustomer, idMission } = useParams();
  const { documents, setDocuments } = usePartnerRequestDetailsStore();

  useEffect(() => {
      gellAllDocuments(Number(idCustomer), Number(idMission))
      .then((res) => {
          setDocuments(res.data);
      })
      .catch(() => {
          showToastError(t("partner.fetchDocumentsError"));
      });
  }, []);

  return (
    <div className="w-screen h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex flex-col justify-start items-start overflow-hidden">
      <Header />
      <div className="w-full flex justify-start items-start">
        <SideBar />
        <ToastContainer position="top-center" />
        <div className="flex flex-col justify-start items-center w-11/12 h-screen m-auto">
          
          {/* Header Section avec design moderne */}
          <div className="w-full bg-white rounded-2xl shadow-lg p-4 my-3 border border-gray-100">
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-blue-100 rounded-xl">
                  <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                <h2 className="text-lg font-bold text-gray-700 font-K2D">
                  {t("partner.documentsTitle")} <span className="text-blue-600">({documents?.length || 0})</span>
                </h2>
                <p className="text-gray-600 text-sm mt-1">
                  {t("partner.documentsSubtitle")}
                </p>
                </div>
              </div>

            </div>
          </div>

          {/* Table des documents avec design moderne */}
          <div className="w-full h-9/12 bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
            <PartnerDocumentsTable />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PartnerDocuments;